module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Group")])], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-form', {
    ref: "groupForm",
    staticClass: "groupForm",
    attrs: {
      "model": _vm.groupForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.group,
      "prop": "value"
    }
  }, [_c('el-select', {
    ref: "groups",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.attrText.inputName
    },
    on: {
      "change": _vm.onChangeSelect
    },
    model: {
      value: (_vm.groupForm.groupId),
      callback: function($$v) {
        _vm.groupForm.groupId = $$v
      },
      expression: "groupForm.groupId"
    }
  }, _vm._l((_vm.groupForm.list), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "select-item",
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.enableSubmitting
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddb968c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/workgroup-add-group.vue
// module id = 621
// module chunks = 4 5 6